import React from "react";
import styled from "styled-components";
import src from "./images/share-with-friends.png";
import { device } from "../../../helpers/style";
// import { Books } from '../../../models'
// import { fixArabicText } from '../../../helpers/text'
// import { Doc } from "../../../models/index";

export const Container = styled.div`
    /*margin: 90px auto 0 auto;*/
    margin: 0 auto;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${device.phone} {
        display: flex;
    } ;
`;
/*const Cover = styled.img`
    cursor: pointer;
    width: 60%;
    border-radius: 4px;
`
const Title = styled.div`
    margin: 10px 0 30px 0;
    padding: 0;
    text-align: center;
    font-size: 20px;
    font-weight: 700 !important;
    font-family: urdu, QuranFont, sans-serif;

    [lang='ar'] {
        font-size: 18px;
    }
`*/

const s = 0.8;
const w = 313 * s;
const h = 124 * s;
const ShareOnFB = styled.img`
    width: ${w}px;
    height: ${h}px;
`;

type Props = {
    counter: number;
    doc: { id: number };
    onClick: (evt: React.MouseEvent<HTMLDivElement>) => void;
};

export default function ShareWithFriends({ counter, doc, onClick }: Props) {
    // if (counter % 3 !== 0) {
    //     return null
    // }

    // const coverImg = Books.url('GET', `${doc.id}/cover`)
    return (
        <Container onClick={onClick}>
            {/*<Cover src={coverImg} alt={doc.name} />*/}
            {/*<Title dangerouslySetInnerHTML={fixArabicText(doc.name)} />*/}
            <ShareOnFB src={src} alt="دوستوں کے ساتھ شئیر کریں" />
        </Container>
    );
}
